<molecule-article-preview-dumb
    [content]="article.synopsis"
    [article]="article"
></molecule-article-preview-dumb>
